<template>
  <div>
    <b-card-code class="mt-2 principal">
      <validation-observer ref="personaValidation">
        <b-form @submit.prevent>
          <b-row class="mt-1 mb-1">
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Estado"
                rules="required"
              >
                <b-form-group
                  label-for="Estado"
                  :state="errors.length > 0 ? false : null"
                >
                  <label>Estado: <span class="text-danger">*</span></label>
                  <v-select
                    id="activo"
                    v-model="selectedEstado"
                    :options="estado"
                    :reduce="(option) => option.value"
                    label="text"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Tipo pasajero persona"
                rules="required"
              >
                <b-form-group
                  label-for="Tipo pasajero persona"
                  :state="errors.length > 0 ? false : null"
                >
                  <label
                    >Tipo pasajero persona:
                    <span class="text-danger">*</span></label
                  >
                  <v-select
                    id="tipo_pasajero"
                    v-model="selectedTipoPersonaPasajero"
                    :options="tipoPersonaPasajero"
                    :reduce="(option) => option.value"
                    label="text"
                    :state="errors.length > 0 ? false : null"
                    @input="limpiarCampos"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="Tipo residente">
                <label>Tipo residente: </label>
                <v-select
                  id="tipo_pasajero"
                  v-model="selectedTipoResidente"
                  :options="tipoResidente"
                  :reduce="(option) => option.value"
                  label="text"
                  @input="limpiarCampos"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Tipo persona"
                rules="required"
              >
                <b-form-group
                  label-for="Tipo persona"
                  :state="errors.length > 0 ? false : null"
                >
                  <label
                    >Tipo persona: <span class="text-danger">*</span></label
                  >
                  <v-select
                    id="tipo_pasajero"
                    v-model="selectedTipoPersona"
                    :options="tipoPersona"
                    :reduce="(option) => option.value"
                    label="text"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Extranjero: </label>
                <b-form-checkbox
                  id="checkbox-3"
                  v-model="extranjero"
                  name="checkbox-3"
                />
              </b-form-group>
            </b-col>
            <b-col :style="personaJuridica" md="4">
              <b-form-group label-for="mc-cedula">
                <label>Cédula: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Cédula"
                  rules="regex:^([a-zA-Z0-9]+)$"
                >
                  <b-form-input
                    id="mc-cedula"
                    v-model="cedula"
                    placeholder="cédula"
                    :state="errors.length > 0 ? false : null"
                    name="cedula"
                    :formatter="formatter"
                    maxlength="10"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="mc-ruc">
                <label>Ruc: </label>
                <validation-provider #default="{ errors }" name="Ruc">
                  <b-form-input
                    id="mc-ruc"
                    v-model="ruc"
                    placeholder="ruc"
                    :state="errors.length > 0 ? false : null"
                    name="ruc"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="mc-razon-social">
                <label>Razón Social: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Razón Social"
                  rules="required"
                >
                  <b-form-input
                    id="mc-razon-social"
                    v-model="razon_social"
                    placeholder="..."
                    :state="errors.length > 0 ? false : null"
                    name="razon_social"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="mc-nombre-comercial">
                <label>Nombre Comercial:</label>
                <b-form-input
                  id="mc-nombre-comercial"
                  v-model="nombre_comercial"
                  placeholder=""
                  name="nombre_comercial"
                />
              </b-form-group>
            </b-col>
            <b-col :style="personaResidentes" md="4">
              <b-form-group label-for="mc-residente-serie">
                <label
                  >Residente serie: <span class="text-danger">*</span></label
                >
                <validation-provider
                  #default="{ errors }"
                  name="Residente serie"
                  rules="integer"
                >
                  <b-form-input
                    id="mc-residente-serie"
                    v-model="residente_serie"
                    placeholder="..."
                    :state="errors.length > 0 ? false : null"
                    name="residente_serie"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col :style="personaResidenteVisible" md="4">
              <b-form-group>
                <label for="residente-fecha-caducidad">
                  Residente fecha caducidad:
                  <span
                    v-if="esResidenteTemporalObligatorio"
                    class="text-danger"
                    >*</span
                  >
                </label>
                <flat-pickr
                  v-model="residente_fecha_caducidad"
                  :config="configdateTimePicker"
                  class="form-control"
                  placeholder="Seleccionar fecha..."
                  :required="esResidenteTemporalObligatorio"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="mc-telefonos">
                <label>Teléfono: </label>
                <b-form-input
                  id="mc-telefonos"
                  v-model="telefonos"
                  placeholder="0000000000"
                  name="telefonos"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="mc-direccion">
                <label>Dirección: </label>
                <b-form-input
                  id="mc-direccion"
                  v-model="direccion"
                  name="direccion"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="mc-email">
                <label
                  >Correo electrónico: 
                  <feather-icon
                    icon="InfoIcon"
                    size="16"
                    v-b-tooltip.hover
                    title="Este correo es el que se va a sincronizar a las factura de contifico."
                  />
                  <span class="text-danger">*</span>
                  </label
                >
                <validation-provider
                  #default="{ errors }"
                  name="Correo electrónico"
                  rules="required"
                >
                  <b-form-tags
                    id="mc-email"
                    v-model="emailArray"
                    placeholder="Ingrese correo y presione enter"
                    remove-on-delete
                    :tag-validator="emailValidator"
                    invalid-tag-text="Correo inválido"
                    duplicate-tag-text="Correo duplicado"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="mc-email-notificacion">
                <label>
                  Correo notificación:
                  <feather-icon
                    icon="InfoIcon"
                    size="16"
                    v-b-tooltip.hover
                    title="Este correo recibirá notificaciones de las órdenes creadas para esta persona."
                  />
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="correo notificación"
                >
                  <b-form-tags
                    id="mc-email-notificacion"
                    v-model="emailNotificacionArray"
                    placeholder="Ingrese correo y presione enter"
                    remove-on-delete
                    :tag-validator="emailValidator"
                    invalid-tag-text="Correo inválido"
                    duplicate-tag-text="Correo duplicado"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1 btn-guardar"
                size="sm"
                @click="validationForm"
              >
                <feather-icon
                  icon="SaveIcon"
                  size="16"
                  class="align-text-top"
                />
                <span>&nbsp;Guardar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-code>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BFormDatepicker,
  VBTooltip,
  BFormTags,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import BCardCode from "@core/components/b-card-code";
import { required, integer, email } from "@validations";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import es from "vee-validate/dist/locale/es.json";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import moment from "moment";
import actions from "@/assets/utils/utils";
import $ from "jquery";
import Vue from "vue";

localize({
  es,
});

localize("es");

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    vSelect,
    BInputGroup,
    BInputGroupAppend,
    BFormDatepicker,
    flatPickr,
    BFormTags,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      residente_serie: "",
      emailArray: [],
      emailNotificacionArray: [],
      nombre_comercial: "",
      razon_social: "",
      identificacion: "",
      cedula: "",
      ruc: "",
      extranjero: false,
      telefonos: "",
      direccion: "",
      required,
      integer,
      token: "",
      selectedEstado: "Activo",
      estado: [
        { value: "Activo", text: "Activo" },
        { value: "Inactivo", text: "Inactivo" },
      ],
      selectedTipoPasajero: "",
      tipoPasajero: [],
      selectedTipoPersona: "",
      tipoPersona: [],
      selectedTipoResidente: "",
      tipoResidente: [],
      selectedTipoPersonaPasajero: "",
      tipoPersonaPasajero: [],
      residente_fecha_caducidad: "",
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "d/m/Y",
        locale: Spanish,
      },
    };
  },
  computed: {
    personaJuridica() {
      return this.selectedTipoPersona === "J"
        ? "display: none;"
        : "display: block;";
    },
    personaGeneralStyles() {
      return this.selectedTipoPersonaPasajero === "GN"
        ? "display: block;"
        : "display: none;";
    },
    personaResidentes() {
      return this.selectedTipoResidente === "R" ||
        this.selectedTipoResidente === "T" ||
        this.selectedTipoResidente === "CT"
        ? "display: block;"
        : "display: none;";
    },
    personaResidenteTemporal() {
      return this.selectedTipoResidente === "T" ||
        this.selectedTipoResidente === "CT"
        ? "display: block;"
        : "display: none;";
    },
    personaResidenteVisible() {
      return this.selectedTipoResidente === "T" ||
        this.selectedTipoResidente === "CT" ||
        this.selectedTipoResidente === "R"
        ? "display: block;"
        : "display: none;";
    },
    esResidenteTemporalObligatorio() {
      return this.selectedTipoResidente === "T";
    },
  },
  mounted() {
    this.cargarTipoPasajero();
    this.cargarTipoPersona();
    if (this.$route.params.token) {
      this.token = this.$route.params.token;
      this.getPersona();
    } else {
      actions.setearTitulo("");
      console.log("NO ENTRO");
    }
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
  },
  methods: {
    emailValidator(tag) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(tag);
    },
    formatter(value) {
      return value.toUpperCase();
    },
    comprobarPermisos() {
      if (
        localStorage.getItem("permisos").indexOf("per_per_registrar") === -1
      ) {
        this.$router.push({ name: "not-permitted" });
      }
    },
    limpiarCampos() {
      this.residente_serie = "";
      this.residente_fecha_caducidad = "";
      this.extranjero = false;
    },
    cargarTipoPersona() {
      axios
        .post("api", {
          query: `{
                    getTipoPersona{
                        lista{
                            text,
                            value,
                        },
                        status,
                        message
                    }
                    getTipoResidente{
                        lista{
                            text,
                            value,
                        },
                        status,
                        message
                    }
                    getTipoPersonaPasajero{
                        lista{
                            text,
                            value,
                        },
                        status,
                        message
                    }
                }`,
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getTipoPersona.status === "success") {
              this.tipoPersona = response.data.data.getTipoPersona.lista;
              this.tipoResidente = response.data.data.getTipoResidente.lista;
              this.tipoPersonaPasajero =
                response.data.data.getTipoPersonaPasajero.lista;
            }
          }
        });
    },
    cargarTipoPasajero() {
      axios
        .post("api", {
          query: `{
                    getTipoPasajero{
                        lista{
                            text,
                            value,
                        },
                        status,
                        message
                    }
                }`,
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getTipoPasajero.status === "success") {
              this.tipoPasajero = response.data.data.getTipoPasajero.lista;
            }
          }
        });
    },
    getPersona() {
      axios
        .post("api", {
          query: `query getPersona($token: String!){
                    getPersona(tokenPersona:$token){
                        persona{
                            token,
                            activo,
                            cedula,
                            ruc,
                            tipoNatJur,
                            tipoPasajero,
                            esExtranjero,
                            razonSocial,
                            email,
                            emailNotificacion,
                            nombreComercial,
                            telefonos,
                            direccion,
                            residente{
                                residente_serie: residenteSerie,
                                residente_fecha_caducidad: residenteFechaCaducidad,
                            }
                            tipoResidente,
                            tipoPersonaPasajero
                        },
                        status,
                        message
                    }
                }`,
          variables: {
            token: this.$route.params.token,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getPersona.status === "success") {
              const datos = response.data.data.getPersona.persona;
              this.selectedTipoPersona = datos.tipoNatJur;
              this.selectedTipoResidente = datos.tipoResidente
                ? datos.tipoResidente
                : "";
              this.selectedTipoPersonaPasajero = datos.tipoPersonaPasajero;
              this.cedula = datos.cedula;
              this.ruc = datos.ruc;
              this.extranjero = datos.esExtranjero;
              this.razon_social = datos.razonSocial;
              this.nombre_comercial = datos.nombreComercial;
              this.emailArray = datos.email ? datos.email.split(',').map(e => e.trim()) : [];
              this.emailNotificacionArray = datos.emailNotificacion ? datos.emailNotificacion.split(',').map(e => e.trim()) : [];
              this.telefonos = datos.telefonos;
              this.direccion = datos.direccion;
              if (datos.residente) {
                this.residente_serie = datos.residente.residente_serie;
                if (
                  datos.residente.residente_fecha_caducidad !== null &&
                  datos.residente.residente_fecha_caducidad !== ""
                ) {
                  this.residente_fecha_caducidad = moment(
                    datos.residente.residente_fecha_caducidad
                  ).format("DD/MM/YYYY");
                } else {
                  this.residente_fecha_caducidad = "";
                }
              } else {
                this.residente_serie = "";
                this.residente_fecha_caducidad = "";
              }
              if (datos.activo === true) {
                this.selectedEstado = "Activo";
              } else {
                this.selectedEstado = "Inactivo";
              }
              actions.setearTitulo(this.identificacion);
            } else {
              this.$router.push({ name: "error-404" });
            }
          }
        });
    },
    validationForm() {
      this.$refs.personaValidation.validate().then((success) => {
        if (success) {
          this.savePersona();
        }
      });
    },
    savePersona() {
      actions.bloquearBoton();
      if (this.ruc === null || this.ruc === "") {
        this.ruc = "";
      }
      this.activo = this.selectedEstado === "Activo";
      axios
        .post("api", {
          query: `mutation createPersona($tipo: String!, $activo: Boolean!, $cedula: String!, $ruc: String!, $esExtranjero: Boolean!, $razonSocial: String!, $nombreComercial: String!, $email: String!, $emailNotificacion: String!, $residenteSerie: String!, $residenteFechaCaducidad: String!, $tokenPersona: String!, $telefonos: String!, $direccion: String!, $tipoResidente: String!, $tipoPersonaPasajero: String!){
                   createPersona(tipo:$tipo, activo:$activo, cedula:$cedula, ruc: $ruc, esExtranjero: $esExtranjero, razonSocial:$razonSocial, nombreComercial:$nombreComercial, email:$email, emailNotificacion:$emailNotificacion, residenteSerie: $residenteSerie, residenteFechaCaducidad: $residenteFechaCaducidad, tokenPersona: $tokenPersona, telefonos: $telefonos, direccion: $direccion, tipoResidente: $tipoResidente, tipoPersonaPasajero: $tipoPersonaPasajero)
                    {
                        persona{
                            token
                        }
                        message,
                        status,
                    }
                }`,
          variables: {
            tipo: this.selectedTipoPersona,
            activo: this.activo,
            cedula: this.cedula === null ? "" : this.cedula,
            ruc: this.ruc === null ? "" : this.ruc,
            esExtranjero: this.extranjero,
            razonSocial: this.razon_social,
            nombreComercial: this.nombre_comercial,
            email: this.emailArray.join(','),
            emailNotificacion: this.emailNotificacionArray.length > 0 ? this.emailNotificacionArray.join(',') : '',
            residenteSerie: this.residente_serie,
            residenteFechaCaducidad: this.residente_fecha_caducidad,
            tokenPersona: this.token,
            telefonos: this.telefonos === null ? "" : this.telefonos,
            direccion: this.direccion === null ? "" : this.direccion,
            tipoResidente:
              this.selectedTipoResidente === null
                ? ""
                : this.selectedTipoResidente,
            tipoPersonaPasajero: this.selectedTipoPersonaPasajero,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.createPersona.status === "success") {
              const { token } = response.data.data.createPersona.persona;
              this.token = token;
              this.showToast();
              if (this.$route.params.token) {
                console.log("");
              } else {
                this.$router.push({ name: "editpersona", params: { token } });
              }
            } else {
              this.$swal({
                title: "Error",
                text: response.data.data.createPersona.message,
                icon: "error",
                confirmButtonColor: "#089599",
              });
            }
          }
          actions.desbloquearBoton();
        });
    },
    showToast() {
      this.$toast.success(
        {
          component: ToastificationContent,
          props: {
            title: "Persona",
            icon: "InfoIcon",
            text: "Se ha guardado con éxito una persona",
          },
        },
        {
          position: "bottom-right",
        }
      );
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
  },
};
</script>
<style>
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
</style>